import { useAppDispatch, useAppSelector } from "../hooks"
import styled from "styled-components";
import { ViewContext } from "../Contexts";
import { app, uiConfig, userReducer } from "@tiffin/app-common";

//Components
import { TifynFooter } from "@tiffin/components";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { NavBar } from "../components/NavBar";
import TifynLogo from "../assets/images/tifyn-logo.png"
import { logInOutline } from "ionicons/icons"
import { IonIcon } from "@ionic/react";
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import { AccountInfoModal } from "../components/account/AccountInfoModal";
import { MenuBar } from "../components/MenuBar";

declare global {
  interface Window { recaptchaVerifier: any; }
}

export const Login = styled(BaseLogin)`
  display: grid;
  grid-template-columns: auto 1fr;
  height: 100%;

  .header {
    background: #fff;
    padding: 20px;
    font-size: var(--font-size-medium);
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 5px;

    ion-icon {
      font-size: var(--font-size-xlarge);
    }
  }

  .page {
    display: grid;
    grid-template-rows: auto 1fr auto;
    height: 100%;

    @media (max-width:768px) {
      width: 100vw;
      padding-bottom: 70px;
    }
  }
`

interface ILoginProps {
  className?: string
}

function BaseLogin({className}: ILoginProps) {
  const partnerUrlName = useAppSelector((state) => state.store.details?.urlName)
  const authenticate = useAppSelector((state) => state.authenticate)

  const [showProfileModal, setShowProfileModal] = useState(false)

  const navigate = useNavigate()
  const [searchParams] = useSearchParams();

  const dispatch = useAppDispatch()
  const view = useContext(ViewContext);

  useEffect(() => {
    if(authenticate.status === "authenticated") {
      navigate({pathname: `/${partnerUrlName}`, search: searchParams.toString()})
    } else if(authenticate.status === "incomplete") {
      setShowProfileModal(true)
    } else if(authenticate.status === "unauthenticated") {
      setShowProfileModal(false)
    }
  }, [navigate, authenticate, partnerUrlName])

  return (
    <div className={className}>
      {
        view === "web" && <NavBar />
      }
      <div className="page">
        <div className="header">
          <IonIcon icon={logInOutline} />
          <span>Sign In</span>
        </div>
        <div className="login">
          <div className="tiffin-logo">
            <img alt="Tifyn Logo" src={TifynLogo} />
          </div>
          {
            authenticate.status === "unauthenticated" &&
            <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={app.auth()} />
          }
        </div>
        {
          view === "web" &&
          <TifynFooter
            logoAlt="Tifyn Logo"
            logoSrc={TifynLogo}
          />
        }
      </div>
      {
        view === "mobile" && <MenuBar />
      }
      <AccountInfoModal 
        open={showProfileModal}
        onClose={() => {
          setShowProfileModal(false)
          dispatch(userReducer.signOutUser("customer"))
        }}
      />
    </div>
  )
}
